const Home: React.FC = () => {
  return <div className="w-full flex flex-col items-center p-2 gap-2"></div>;
};

export default Home;
